:host {
  ::slotted(ld-pagination) {
    flex-shrink: 0;
    overflow-x: hidden;
    padding-bottom: var(--ld-sp-8);
    padding-top: var(--ld-sp-4);
    transform: translateY(var(--ld-sp-2));
  }

  ::slotted(ld-pagination:first-child) {
    margin-left: calc(-1 * var(--ld-sp-8));
  }
  ::slotted(ld-pagination:last-child) {
    margin-right: calc(-1 * var(--ld-sp-8));
  }
}
